import { motion } from "framer-motion";

type Props = {
  className?: string;
  withTopBorder?: boolean;
};

type Partner = {
  name: string;
  label: string;
  href: string;
  logo: string;
  alt: string;
  tagline: string;
  /** Tailwind height classes — tuned per logo so the marks read at a balanced optical size. */
  logoClass: string;
};

/**
 * Festival partners. Add future confirmed sponsors here and they appear
 * everywhere this block is rendered (homepage, Travel, Tickets, Lineup, Artist pages).
 */
const partners: Partner[] = [
  {
    name: "Cambria",
    label: "Official Hotel Partner",
    href: "https://cambriadetroit.com/",
    logo: "/cambria-logo.png",
    alt: "Cambria Hotel Detroit Downtown — Official Hotel Partner of Yacht Rock Detroit",
    tagline: "Detroit's Official Festival Hotel",
    logoClass: "h-20 md:h-24",
  },
  {
    name: "iHeartMedia",
    label: "Official Media Partner",
    href: "https://www.iheartmedia.com/",
    logo: "/iheartmedia-logo.png",
    alt: "iHeartMedia — Official Media Partner of Yacht Rock Detroit",
    tagline: "Detroit's Hometown Radio",
    logoClass: "h-9 md:h-11",
  },
];

const SponsorsBlock = ({ className = "", withTopBorder = true }: Props) => {
  return (
    <motion.div
      className={`flex flex-col items-stretch md:flex-row md:justify-center gap-10 md:gap-0 ${
        withTopBorder ? "pt-10 md:pt-14 border-t border-yacht-charcoal/10" : ""
      } ${className}`}
      initial={{ opacity: 0, y: 12 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
    >
      {partners.map((partner, i) => (
        <div
          key={partner.name}
          className={`flex flex-1 flex-col items-center justify-start gap-5 text-center md:px-8 ${
            i > 0 ? "md:border-l md:border-yacht-charcoal/10" : ""
          }`}
        >
          <p className="text-yacht-blue text-[11px] md:text-xs font-bold tracking-[0.3em] uppercase">
            ★ {partner.label} ★
          </p>
          <a
            href={partner.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={partner.alt}
            className="inline-flex flex-1 items-center justify-center transition-opacity hover:opacity-80"
          >
            <img
              src={partner.logo}
              alt={partner.alt}
              className={`${partner.logoClass} w-auto max-w-full object-contain`}
              loading="lazy"
            />
          </a>
          <p
            className="text-yacht-charcoal/70 text-sm md:text-base italic"
            style={{ fontFamily: "Georgia, 'Times New Roman', serif" }}
          >
            {partner.tagline}
          </p>
        </div>
      ))}
    </motion.div>
  );
};

export default SponsorsBlock;
